/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import BiComponentError from 'js-sdk/src/common/bi/error/BiComponentError';
import errorCodes from 'js-sdk/src/common/bi/error/enum/biComponentErrorCodes';
import messages from 'js-sdk/src/common/bi/error/enum/biComponentErrorMessages';

export default BiComponentError.extend({
    constructor: function (errorObj) {
        if (_.isString(errorObj)) {
            errorObj = { parameters: [errorObj] };
        }
        var code = errorCodes['AD_HOC_VIEW_RENDER_ERROR'], msg = messages[code];
        if (errorObj.type === 'highchartsInternalError') {
            code = errorCodes['REPORT_RENDER_HIGHCHARTS_ERROR'];
            if (errorObj.data.message) {
                msg = errorObj.data.message;
            } else {
                msg = errorObj.data.error;
            }
        }
        BiComponentError.prototype.constructor.call(this, code, msg, errorObj.parameters || []);
    }
});
